import { geoAPI } from "@services/index";
import { usePathname } from "next/navigation";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { isBot } from "utils";

type GeoData = {
  isRestricted: boolean;
  region: string;
  countryCode: string;
  country: string;
};

type GeoApiResponse = {
  data: GeoData;
};

const blockedPages = [
  "/gain/growth-vault/",
  "/gain/airdrop-gain/",
  "/gain/stable-vault/",
];

const useRegionCheck = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [response, setResponse] = useState<GeoData | null>(null);
  const [showContent, setShowContent] = useState(false);
  const router = useRouter();

  const pathname = usePathname();
  const isBotUser = isBot();
  const isBlockedPage = pathname === "/blocked/";

  // Check if current page is in the blocked pages list
  const isCurrentPageBlocked = blockedPages.some((blockedPage) =>
    pathname?.startsWith(blockedPage)
  );

  const isRestricted = response?.isRestricted;

  // Only redirect to blocked page if user is restricted AND on a blocked page
  const shouldBlock = isRestricted && isCurrentPageBlocked;

  useEffect(() => {
    if (!isLoading && !isBlockedPage && shouldBlock) {
      router.replace("/blocked");
    }
  }, [shouldBlock, isLoading, isBlockedPage]);

  useEffect(() => {
    setIsLoading(true);
    geoAPI()
      .then((res: GeoApiResponse) => {
        setResponse(res?.data || null);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const showComponent =
    isBotUser || isBlockedPage || (!isLoading && !shouldBlock && showContent);

  const onLoopComplete = () => {
    if (!isLoading) setShowContent(true);
  };

  return { onLoopComplete, showComponent };
};

export default useRegionCheck;
